/*
 * birthdate creates the birthdate validation.
 *
 * Requires element with class 'js-validate-birthdate'.
 *
 * GDL Requirements
 * - leap years should be taken in account
 * - you have to be younger than 110
 * - you have to be at least 18
 * - the date calculations need to be with today's date, someone who turned 18 today must be able to enter
 *
 *
 * 12-aa-1950 = ongeldige maand
 * 31-06-1950 = 31 juni bestaat niet
 * 29-02-1991 = geen schrikkeljaar
 * 29-02-1992 = schrikkeljaar
 *
 *
 * Dependencies
 * - jQuery Validate https://jqueryvalidation.org/
 */

function birthdate() {
	/* Self executing function so all elements exist when this is executed */
	document.addEventListener('DOMContentLoaded', () => {
		if ($('.js-validate-birthdate').length < 1 || $('.js-validate-birthdate') > 1) {
			return;
		}

		if (!window.validateExists()) {
			return;
		}

		/* Don't continue if */
		const $day = $('.js-validate-birthdate #bday-day');
		const $month = $('.js-validate-birthdate #bday-month');
		const $year = $('.js-validate-birthdate #bday-year');
		const $notOfAgeMessage = $('.js-validate-birthdate #bday-alert');
		$notOfAgeMessage.hide();

		if (typeof $day === 'undefined' || typeof $month === 'undefined' || typeof $year === 'undefined') {
			return;
		}

		const minAge = 18;
		const maxAge = 110;

		function revalidateBdayFields(element) {
			/* Revalidate the rest */
			if (!$(element).data('reval')) {
				$('.js-validate-birthdate input').each(function iterator() {
					if ($(this).val() !== '') {
						$(this).data('reval', true).valid();
						$(this).data('reval', false);
					}
				});
			}
		}

		function resetOptionalStylingBdayFields(ageIsFine) {
			if (ageIsFine) {
				resetNotOfAgeSingleIcon();
			} else {
				setNotOfAgeSingleIcon();
			}
		}

		function setNotOfAgeSingleIcon() {
			$day.addClass('input-validation-error-without-icon');
			$month.addClass('input-validation-error-without-icon');
		}

		function resetNotOfAgeSingleIcon() {
			$day.removeClass('input-validation-error-without-icon');
			$month.removeClass('input-validation-error-without-icon');
		}

		$month.on('blur', () => {
			$day.valid();
		});

		$year.on('blur', () => {
			$month.valid();
			$day.valid();
		});

		/* Add jQuery Validation Rules */
		jQuery.validator.addMethod('tooOld', (value, element) => {
			/* Remove leading zero's for proper comparison and parse as int */
			const dayVal = parseInt($day.val().replace(/^0+/, ''), 10);
			const monthVal = parseInt($month.val().replace(/^0+/, ''), 10);
			const yearVal = parseInt($year.val(), 10);

			let ageIsFine = true;

			/* This is the date that was put in */
			const date = new Date(yearVal, monthVal - 1, dayVal);

			/* Max date, since max age is 110 */
			const maxdate = new Date(new Date().setFullYear(new Date().getFullYear() - maxAge));

			/* The age is fine IF the given date is no more than 110 years ago */
			ageIsFine = date > maxdate;

			revalidateBdayFields(element, ageIsFine);
			resetOptionalStylingBdayFields(ageIsFine);

			if ($day.val().length === 0 || $month.val().length === 0 || $year.val().length === 0) {
				ageIsFine = true;
			}

			return ageIsFine;
		});

		jQuery.validator.addMethod('tooYoung', (value, element) => {
			/* Remove leading zero's for proper comparison and parse as int */
			const dayVal = parseInt($day.val().replace(/^0+/, ''), 10);
			const monthVal = parseInt($month.val().replace(/^0+/, ''), 10);
			const yearVal = parseInt($year.val(), 10);

			let ageIsFine = true;

			/* This is the date that was put in */
			const date = new Date(yearVal, monthVal - 1, dayVal);

			/* Max date, since max age is 110 */
			const mindate = new Date(new Date().setFullYear(new Date().getFullYear() - minAge));

			/* The age is fine IF the given date is at least 18 years ago */
			ageIsFine = date < mindate;

			revalidateBdayFields(element, ageIsFine);
			resetOptionalStylingBdayFields(ageIsFine);

			if ($day.val().length === 0 || $month.val().length === 0 || $year.val().length === 0) {
				ageIsFine = true;
			}

			return ageIsFine;
		});

		jQuery.validator.addMethod('doesNotExist', (value, element) => {
			/* Remove leading zero's for proper comparison and parse as int */
			const dayVal = parseInt($day.val().replace(/^0+/, ''), 10);
			const monthVal = parseInt($month.val().replace(/^0+/, ''), 10);
			const yearVal = parseInt($year.val(), 10);

			let dateExists = true;

			/* This is the date that was put in */
			const date = new Date(yearVal, monthVal - 1, dayVal);

			dateExists = date.getFullYear() === yearVal && date.getMonth() + 1 === monthVal && date.getDate() === dayVal;

			revalidateBdayFields(element);
			if ($day.val().length === 0 || $month.val().length === 0 || $year.val().length === 0) {
				dateExists = true;
			}

			return dateExists;
		});

		$('#bday-day').rules('add', {
			tooOld: true,
			tooYoung: true,
			doesNotExist: true,
			messages: {
				required: 'Sorry, wij kunnen uw geboortedatum alleen verwerken als u deze op de volgende manier invult: dd-mm-jjjj.',
				tooOld: 'Sorry, deelnemen aan de loterij kan vanaf 18 jaar.',
				tooYoung: 'Sorry, deelnemen aan de loterij kan vanaf 18 jaar.',
				doesNotExist: 'Sorry, wij kunnen uw geboortedatum alleen verwerken als u deze op de volgende manier invult: dd-mm-jjjj.'
			}
		});

		$('#bday-month').rules('add', {
			tooOld: true,
			tooYoung: true,
			doesNotExist: true,
			messages: {
				required: 'Sorry, wij kunnen uw geboortedatum alleen verwerken als u deze op de volgende manier invult: dd-mm-jjjj.',
				tooOld: 'Sorry, deelnemen aan de loterij kan vanaf 18 jaar.',
				tooYoung: 'Sorry, deelnemen aan de loterij kan vanaf 18 jaar.',
				doesNotExist: 'Sorry, wij kunnen uw geboortedatum alleen verwerken als u deze op de volgende manier invult: dd-mm-jjjj.'
			}
		});

		$('#bday-year').rules('add', {
			tooOld: true,
			tooYoung: true,
			doesNotExist: true,
			messages: {
				required: 'Sorry, wij kunnen uw geboortedatum alleen verwerken als u deze op de volgende manier invult: dd-mm-jjjj.',
				tooOld: 'Sorry, deelnemen aan de loterij kan vanaf 18 jaar.',
				tooYoung: 'Sorry, deelnemen aan de loterij kan vanaf 18 jaar.',
				doesNotExist: 'Sorry, wij kunnen uw geboortedatum alleen verwerken als u deze op de volgende manier invult: dd-mm-jjjj.'
			}
		});

		let requiredCheckIsSet = false;
		function addRequiredCheck() {
			if (!requiredCheckIsSet) {
				requiredCheckIsSet = true;
				if ($('#bday-day').attr('data-val-required') !== undefined) {
					// There's no need since campaign-pages added required
					return;
				}
				if ($('#bday-day').val() !== '' || $('#bday-month').val() !== '' || $('#bday-year').val() !== '') {
					$('#bday-year').rules('add', {
						required: () => $('#bday-day').val() !== '' || $('#bday-month').val() !== ''
					});

					$('#bday-month').rules('add', {
						required: () => $('#bday-day').val() !== '' || $('#bday-year').val() !== ''
					});

					$('#bday-day').rules('add', {
						required: () => $('#bday-year').val() !== '' || $('#bday-month').val() !== ''
					});
				}
			}
		}
		$('#bday-day').on('blur', addRequiredCheck);
		$('#bday-month').on('blur', addRequiredCheck);
		$('#bday-year').on('blur', addRequiredCheck);
	});
}

export default birthdate;
